import styled from "styled-components";
import zIndexTypes from "../../../theme/zIndexTypes";
import {
  mediaMaxHeight,
  mediaMinWidth,
  mediaMaxWidth,
} from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div``;

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxHeight.phone`
    align-items: unset;
  `}

  ${mediaMaxWidth.tablet`
    align-items: unset;
  `}

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInDown {
    animation-name: fadeInDown;
  }

  .animated,
  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }
`;

export const ModalWrapper = styled.div`
  background-color: #3b045d;
  border-radius: 8px;
  width: 800px;
  height: 600px;
  z-index: ${zIndexTypes.modal};
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop`
    margin-left: unset;
    width: calc(100vw - 30px);
  `}

  ${mediaMaxWidth.tablet`
    top: 10px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 20px);
    padding: 10px 10px;
    height: ${(props) =>
      props.iOS ? "calc(100vh - 110px)" : "calc(100vh - 120px)"};
  `}

  ${mediaMaxHeight.phone`
    top: 10px;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #fff;
  color: #fff;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop`
    width: 95%;
  `}
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #fff;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #79D9D9;
    }
  }
`;

export const StepButtons = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 500px;
  top: 8px;

  ${mediaMaxWidth.tablet`
    width: 400px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
    z-index: 1;
    padding: 10px 0;
    top: 0;
  `}
`;

export const PrevButton = styled.div`
  width: 100px;
  z-index: 3;
  height: 40px;
  width: 40px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: #79D9D9;

    svg {
      color: #fff;
    }
  }
`;

export const NextButton = styled.div`
  width: 100px;
  z-index: 3;
  text-align: right;
  margin-left: auto;
  height: 40px;
  width: 40px;
  background-color: #79D9D9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s ease-in-out;
  cursor: pointer;

  svg {
    color: #fff;
  }

  &:hover {
    background-color: #fff;

    svg {
      color: #565656;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 500px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  ${mediaMaxWidth.tablet`
    width: 400px;
    padding-bottom: 30px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
    height: ${(props) => (props.iOS ? "435px" : "465px")};
  `}

  ${mediaMaxWidth.smallPhone`
    width: 83vw;
  `}
`;

export const CurrentComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${mediaMaxWidth.phone`
    height: ${(props) =>
      props.iOS ? "calc(100vh - 225px)" : "calc(100vh - 160px)"};
    flex: unset;
    display: unset;
    padding-bottom: 15px;
    overflow-y: auto;
    position: relative;
    top: 45px;
  `}
`;

export const SectionTitle = styled.div`
  z-index: 2;
  font-size: 1.2em;
  color: #fff;
  font-weight: 600;
  padding: 5px 10px;
  margin: 5px 0;
  display: flex;
  justify-content: center;

  ${mediaMaxWidth.phone`
    position: fixed;
    right: 0;
    left: 0;
    width: 225px;
    margin: 0 auto;
    top: 15px;
    display: flex;
    align-items: center;
  `}
`;

export const Label = styled.label`
  display: flex;
  font-size: 0.9em;
  color: #fff;
  height: 17px;
  position: relative;
  justify-content: space-between;
  margin-top: ${(props) => props.benefits && "10px"};
  margin-top: ${(props) => props.salary && "7px"};

  ${mediaMaxWidth.phone`
    display: ${(props) => props.noMobile && "none"};
  `}
`;

export const Field = styled.div`
  position: relative;
  flex: ${(props) => props.location && "2"};
  margin-right: ${(props) => props.location && "15px"};
  margin: ${(props) => props.radioButtons && "2px 0"};

  ${mediaMaxWidth.phone`
    width: ${(props) => props.postCode && "120px"};
  `}
`;

export const Error = styled.div`
  position: absolute;
  bottom: -3px;
  bottom: ${(props) => props.sector && "-8px"};
  text-align: center;
  text-align: ${(props) => props.salaryMin && "left"};
  text-align: ${(props) => props.salaryMax && "right"};
  font-size: 0.75em;
  width: 100%;
  color: #79D9D9;
  font-weight: 600;

  ${mediaMaxWidth.phone`
    bottom: ${(props) => props.jobTitle && "-18px"};
    bottom: ${(props) => props.location && "-18px"};
    bottom: ${(props) => props.salaryMinSingle && "-18px"};
    bottom: ${(props) => props.agencyFee && "-18px"};
    bottom: ${(props) => props.mustHaves && "-20px"};
    bottom: ${(props) => props.notifications && "-20px"};
  `}
`;

export const LabelText = styled.div`
  position: relative;
`;

export const LabelIcon = styled.div`
  svg {
    cursor: pointer;
  }

  .__react_component_tooltip.show {
    max-width: 300px;
  }
`;

export const Required = styled.span`
  font-weight: 400;
  font-size: 1.5em;
  position: absolute;
  top: -5px;
  right: -15px;
  color: #79D9D9;
`;

export const Input = styled.input`
  display: flex;
  border: ${(props) =>
    props.error ? "2px solid #79D9D9" : "2px solid #e7e7e7"};
  border-radius: 4px;
  width: 100%;
  resize: none;
  padding: 7px 10px;
  position: relative;
  margin: 5px 0 15px 0;
  margin-top: ${(props) => props.salary && "10px"};
  color: #000;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  ${mediaMaxWidth.phone`
    margin: ${(props) => props.mobileMargin && "5px 0 20px 0"};
  `}
`;

export const Select = styled.select`
  background-color: #fff;
  border: ${(props) =>
    props.error ? "2px solid #79D9D9" : "2px solid #e7e7e7"};
  height: 46px;
  width: 100%;
  text-transform: capitalize;
  margin: 0 0 10px 0;
  color: #000;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const Option = styled.option``;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: ${(props) => (props.iOS ? "78px" : "0")};
  left: 0;
  right: 0;
  background-color: #3b045d;

  ${mediaMaxWidth.phone`
    z-index: 1;
    position: fixed;
    bottom: 10px;
    height: 70px;
    align-items: center;
    left: unset;
    right: unset;
    width: calc(100vw - 55px);
  `}

  ${mediaMaxWidth.smallPhone`
    bottom: 5px;
    height: 60px;
    width: calc(100vw - 50px);
  `}
`;

export const EditorWrapper = styled.div`
  position: relative;

  ${Error} {
    bottom: -20px;
  }

  .editor-toolbar {
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    margin-bottom: 15px;
    height: 60px;

    ${mediaMaxWidth.phone`
      display: none;
    `}

    .rdw-option-wrapper {
      border: 2px solid #fff;
      border-radius: 4px;
      height: 30px;
      width: 35px;

      &:hover {
        border: 2px solid #402680;
        box-shadow: none;
      }
    }

    .rdw-option-wrapper.rdw-option-active {
      border: 2px solid #402680;
      box-shadow: none;

      &:hover {
        border: 2px solid #402680;
        box-shadow: none;
      }
    }
  }

  .editor {
    padding: 10px;
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    min-height: 17em;
    height: 17em;
    background-color: #fff;
    color: #000;

    .public-DraftStyleDefault-block {
      margin: 0;
    }

    &:focus {
      border-color: #79D9D9;
      outline: none;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }

    ${mediaMaxWidth.phone`
      min-height: 21em;
      height: 21em;
    `}

    ${mediaMaxWidth.smallPhone`
      min-height: 16em;
      height: 16em;
    `}
  }
`;

export const CheckBoxesGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 20px;

  ${mediaMaxWidth.phone`
    flex-flow: unset;
    flex-direction: column;
    margin-bottom: 30px;
  `}
`;

export const CheckBoxesGroupItem = styled.div`
  display: flex;
  flex-direction: row;
  margin: 5px 0;

  ${mediaMaxWidth.phone`
    width: 100%;
  `}
`;

export const Indicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  border-radius: 4px;
  background: #fff;
  border: 2px solid #e7e7e7;
  transition: 0.1s ease-in-out;

  &:after {
    content: "\f00c ";
    font-family: FontAwesome;
    position: absolute;
    top: -4px;
    left: 0;
    color: #fff;
  }

  &:hover {
    border: 2px solid #79D9D9;
  }
`;

export const CheckBoxWrap = styled.div`
  display: flex;
  margin: 5px 0 10px 0;
`;

export const CheckBoxInput = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:checked ~ ${Indicator} {
    background: #79D9D9;
    border: 2px solid #79D9D9;

    &:after {
      display: block;
    }
  }
`;

export const CheckBoxLabel = styled.label`
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
  font-weight: 400;
  color: #fff;
`;

export const Check = styled.div`
  display: block;
  position: absolute;
  left: 0;
  border: 3px solid #e7e7e7;
  border-radius: 100%;
  height: 20px;
  width: 20px;
  transition: border 0.25s linear;

  &:before {
    display: block;
    position: absolute;
    content: "";
    border-radius: 100%;
    height: 10px;
    width: 10px;
    top: 2px;
    left: 2px;
    margin: auto;
    transition: background 0.1s linear;
  }
`;

export const RadioButtonsLabel = styled.label`
  font-size: 0.9em;
  color: #fff;
  height: 17px;
  position: absolute;
  top: 5px;

  ${mediaMaxWidth.phone`
    top: -22px;
  `}
`;

export const RadioButtonGroup = styled.ul`
  display: flex;
  margin: 5px 0 10px auto;
  padding: 0;
  width: 350px;

  ${mediaMaxWidth.tablet`
    margin: 30px 0 5px auto;
    width: unset;
  `}
`;

export const RadioButtonWrapper = styled.li`
  display: flex;
  flex: 1;
  align-items: center;
  position: relative;
  top: 0;
  margin: 10px 0px;
  transition: 0.1s ease-in-out;

  &:hover {
    ${Check} {
      border: 3px solid #79D9D9;
    }
  }
`;

export const RadioButton = styled.input`
  margin: -3px 0 0 !important;
  position: absolute;
  visibility: hidden;

  &:checked ~ ${Check} {
    border: 3px solid #79D9D9;
  }

  &:checked ~ ${Check}::before {
    background: #79D9D9;
  }

  &:checked ~ label {
    color: #79D9D9;
  }
`;

export const RadioButtonLabel = styled.label`
  font-weight: 400;
  font-size: 0.95em;
  position: absolute;
  color: #fff;
  left: 0;
  padding: 0 30px;
  z-index: 1;
  transition: 0.1s ease-in-out;
  cursor: pointer;

  &:hover {
    color: #79D9D9;
  }
`;

export const ContractDuration = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DurationElement = styled.div`
  display: flex;
  flex-direction: column;

  &:nth-child(1) {
    flex: 2;
  }

  &:nth-child(2) {
    margin-left: 20px;
    flex: 5;
  }
`;

export const Salary = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const SalaryElement = styled.div`
  display: flex;
  flex-direction: column;
  flex: 4;
`;

export const Divider = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  color: #fff;
  justify-content: center;
  align-items: center;
  font-weight: 500;
`;

export const MustHavesInputWrapper = styled.div`
  .react-tagsinput {
    background-color: #fff;
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    padding: 10px;
    min-height: 46px;
    margin-bottom: 20px;

    &:hover {
      border-color: #79D9D9;
      outline: none;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }

  .react-tagsinput--focused {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  .react-tagsinput-tag {
    background-color: #402680;
    border-radius: 2px;
    border: 1px solid #402680;
    color: #fff;
    display: inline-block;
    font-size: 15px;
    font-weight: 400;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 1px 5px;
  }

  .react-tagsinput-remove {
    cursor: pointer;
    font-weight: bold;
    margin-left: 10px;

    &:before {
      content: "x";
      color: #79D9D9;
      font-size: 13px;

      &:hover {
        color: #79D9D9;
      }
    }
  }

  .react-tagsinput-input {
    border: none;
    display: block;
    width: 100%;

    &:focus {
      outline: none;
    }
  }
`;

export const Location = styled.div`
  display: flex;
  justify-content: space-between;
`;
